import { parseISO } from "date-fns";
import getFormattedDate from "./getFormattedDate";

/**
 * Formats a check timestamp in UTC.
 *
 * The API reports these instants in UTC and the widget is embedded on host pages
 * worldwide, so rendering them in the viewer's zone would show a different time
 * than the one the check was recorded at.
 */
export default function getFormattedDateWithTime(
  date: string | number,
  format = "dd.MM.yyyy HH:mm",
) {
  const parsed = typeof date === "string" ? parseISO(date) : new Date(date);
  // date-fns formats in the local zone, and an ISO string with no zone suffix is
  // parsed as local — so dropping the "Z" makes it print the UTC reading.
  const utc = parseISO(parsed.toISOString().slice(0, 19));

  return getFormattedDate(utc.getTime(), format);
}
